import {
  createFeatureSelector,
  createSelector,
  Action,
  combineReducers,
} from '@ngrx/store';

import { getAllAccounts } from '@account-users/account/state';

import * as fromSenderDomain from './sender-domain.reducer';
import * as fromTemplates from './template.reducer';

export interface State {
  senderDomain: fromSenderDomain.State;
  templates: fromTemplates.State;
}

export function reducers(state: State | undefined, action: Action) {
  return combineReducers({
    senderDomain: fromSenderDomain.reducer,
    templates: fromTemplates.reducer,
  })(state, action);
}

export const getEmailModuleState = createFeatureSelector<State>('email');

export const getAccountsSortedByName = createSelector(
  getAllAccounts,
  (accounts) => [
    ...accounts.sort((a, b) => a.displayName.localeCompare(b.displayName)),
  ],
);

export const getSenderDomainState = createSelector(
  getEmailModuleState,
  (state) => state.senderDomain,
);
export const {
  selectAll: getSenderDomains,
} = fromSenderDomain.adapter.getSelectors(getSenderDomainState);

export const getTemplatesState = createSelector(
  getEmailModuleState,
  (state) => state.templates,
);
export const { selectAll: getTemplates } = fromTemplates.adapter.getSelectors(
  getTemplatesState,
);
